import './radio-custom.css';

interface RadioCustomProps {
  checked: boolean;
  content: string;
  onClick?: () => void;
}

export const RadioCustom = ({ checked, content, onClick }: RadioCustomProps) => {
  return (
    <div className='radio-custom' onClick={onClick}>
      <div className={!checked ? 'unchecked' : 'checked-background'}>
        <div className='checked-button'></div>
      </div>
      <span className='text-radio'>{content}</span>
    </div>
  );
};
